import { cloneDeep } from 'lodash';
import { Line } from 'vue-chartjs';
export default {
  name: 'CoreChartJsLineChart',
  extends: Line,
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    datasets: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    labels: {
      handler: function () {
        this.render();
      },
      deep: true
    },
    datasets: {
      handler: function () {
        this.render();
      },
      deep: true
    },
    options: {
      handler: function () {
        this.render();
      },
      deep: true
    }
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      const clonedOptions = cloneDeep(this.options);

      // TODO: label color based on dark/light theme
      this.renderChart({
        labels: cloneDeep(this.labels),
        datasets: cloneDeep(this.datasets)
      }, {
        responsive: true,
        maintainAspectRatio: false,
        ...clonedOptions
      });
    }
  }
};